var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccShips(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ships",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8392",
    "data-name": "Rectangle 8392",
    width: 28,
    height: 28,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35247",
    "data-name": "Group 35247",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35891",
    "data-name": "Path 35891",
    d: "M24.76,16.23h.048V8.184A2.709,2.709,0,0,0,22.1,5.47h-3.6V2.853H9.4V5.47H5.907a2.709,2.709,0,0,0-2.714,2.7V16.23h0c-.616.227-1.225.447-1.845.678.582,2.715,1.164,5.331,1.842,8.046a9.258,9.258,0,0,1,4.265-1.26c2.907-.1,3.489,1.454,6.3,1.454,3.1,0,3.877-1.745,6.979-1.551a9.527,9.527,0,0,1,4.071,1.357c.582-2.715,1.26-5.331,1.842-8.046-.625-.227-1.26-.451-1.889-.678M7.361,9.251H20.738V13.9l-5.623-1.842a3.981,3.981,0,0,0-2.133,0L7.361,13.9Z",
    fill: "#b3b5c4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccShips);
export default __webpack_public_path__ + "static/media/mcc_ships.bca653e5ea66867d52ea65ae48c8775e.svg";
export { ForwardRef as ReactComponent };